/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_TitleInputs */

const et_portfolio_title = /** @type {(inputs: Portfolio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfoolio — Tõestatud Veebidisaini & SEO Tulemused | ScalingWebs`)
};

const en_portfolio_title = /** @type {(inputs: Portfolio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfolio — Proven Web Design & SEO Results | ScalingWebs`)
};

/**
* | output |
* | --- |
* | "Portfolio — Proven Web Design & SEO Results \| ScalingWebs" |
*
* @param {Portfolio_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_title = /** @type {((inputs?: Portfolio_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_title(inputs)
	return en_portfolio_title(inputs)
});